var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#36c5f0;}.b{fill:#2eb67d;}.c{fill:#ecb22e;}.d{fill:#e01e5a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.482,11.587a2.483,2.483,0,0,1,0-4.966H9.1a2.483,2.483,0,0,1,0,4.966ZM9.1,4.964A2.482,2.482,0,1,1,9.1,0h0a2.484,2.484,0,0,1,2.484,2.483V4.964Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.62,11.587V9.1A2.484,2.484,0,1,1,9.1,11.587ZM0,9.1V2.482a2.483,2.483,0,0,1,4.965,0V9.1A2.483,2.483,0,1,1,0,9.1Z",
    transform: "translate(12.414)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,9.1V6.622H2.483A2.482,2.482,0,1,1,0,9.1ZM2.483,4.965A2.483,2.483,0,1,1,2.484,0H9.1a2.483,2.483,0,0,1,0,4.965Z",
    transform: "translate(12.414 12.414)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.62,9.1V2.483h0a2.483,2.483,0,0,1,4.966,0V9.1a2.483,2.483,0,0,1-4.966,0ZM0,2.482A2.483,2.483,0,0,1,2.483,0H4.966V2.482A2.483,2.483,0,0,1,0,2.482Zm6.62,0h0Z",
    transform: "translate(0 12.414)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSlack);
export default __webpack_public_path__ + "static/media/logo-slack.cd48b339ddcc336030e0c46b32f4d835.svg";
export { ForwardRef as ReactComponent };